export function selectedPOIs(state) {
    return state.selectedPOIs
}

export function loadingPOIs(state) {
    return state.loadingPOIs
}

export function poiLoading(state) {
    return state.poiLoading
}

export function poiResults(state) {
    return state.poiResults
}

export function activePoiId(state) {
    return state.activePoiId
}

export function trafficPOIselected(state) {
    return state.trafficPOIselected
}

export function isNearbyStationsListOpen(state) {
    return state.isNearbyStationsListOpen
}

export function myOeamtcBase(state) {
    return state.myOeamtcBase
}

export function customActivePoiType(state) {
    return state.customActivePoiType
}

export function customActivePoiSubType(state) {
    return state.customActivePoiSubType
}

export function poiPaginationData(state) {
    return state.poiPaginationData
}

export function poiSorting(state) {
    return state.poiSorting
}

export function poiApiErrors(state) {
    return state.poiApiErrors
}

export function poiToRemoveFromMap(state) {
    return state.poiToRemoveFromMap
}

export function previousActivePoi(state) {
    return state.previousActivePoi
}

export function dynamicPoiElements(state) {
    return state.dynamicPoiElements
}